import React from 'react';
import { Formik, Form, FormikHelpers, FormikProps } from 'formik';

export interface ChedaGamingFormProps<T> {
  initialValues: T;
  validationSchema?: any;
  onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => Promise<void> | void;
  children: (formik: FormikProps<T>) => React.ReactNode;
}

export function ChedaGamingForm<T>({ initialValues, validationSchema, onSubmit, children }: ChedaGamingFormProps<T>) {
  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {(formik) => (
        <Form noValidate>
          {children(formik)}
        </Form>
      )}
    </Formik>
  );
}

export default ChedaGamingForm;
